import React from 'react';
import './Underline.css';

export default function Underline () {
    
    return (
      <hr className="underline"/>
    );
  }